var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"page-con"},[(_vm.visible)?_c('InJzxTool',{attrs:{"page-type":"5","page-params":_vm.pageParams},on:{"event-handle":_vm.eventHandle}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }